import { render } from "./AuthTrigger.vue?vue&type=template&id=7bdef688&lang=pug"
import script from "./AuthTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthTrigger.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__